/**
 * Setear exclusiones
 */
export function setExclusions(state, exclusions) {
	state.exclusions = exclusions;
}

/**
 * Agregar exclusión
 */
export function addExclusion(state, exclusion) {
	state.exclusions.unshift(exclusion);
}

/**
 * Actualizar exclusión
 */
export function updateExclusion(state, updated) {
	const index = state.exclusions.findIndex(e => e.id === updated.id);
	if (index !== -1) {
		state.exclusions.splice(index, 1, updated);
	}
}

/**
 * Eliminar exclusión
 */
export function removeExclusion(state, id) {
	state.exclusions = state.exclusions.filter(e => e.id !== id);
}

/**
 * Params
 */
export function setContactIdToParams(state, contact_id) {
	state.params.contact_id = contact_id;
}

export function setWarehouseIdToParams(state, warehouse_id) {
	state.params.warehouse_id = warehouse_id;
}

export function setProductIdToParams(state, product_id) {
	state.params.product_id = product_id;
}



// WEBPACK FOOTER //
// ./src/b2b/modules/statistics-product-sale-client-exclusion/mutations.js